import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { getagent } from '../redux/agent';
import Loader from '../components/Loader';

export default function BasicModal(props) {
 
  const [open, setOpen] = React.useState(props.value);
  const [loading, setLoading] = React.useState(false);
  const [checked, setChecked] = React.useState([]);
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState('');
  const dispatch = useDispatch();

  // Add useEffect to handle permission preselection
  React.useEffect(() => {
    if (props.chosen && props.chosen.permissions) {
      setChecked(props.chosen.permissions);
    }
  }, [props.chosen]);

  const handleClose = () => {
    setOpen(false);
    props.setfalser();
  };

  const handleSnackbarClose = () => setSnackbarOpen(false);

  const clearForm = () => {
    setChecked([]);
  };

  const handleCheck = (event) => {
    const value = event.target.checked;
    const permission = event.target.value;
    let updatedPermissions = [];

    if (value) {
      updatedPermissions = [...checked, permission];
    } else {
      updatedPermissions = checked.filter((item) => item !== permission);
    }

    setChecked(updatedPermissions);
  };

  const submitPermissions = async () => {
    setLoading(true);
    try {
      const link = props.link;
      const res = await axios.post(link, {
        _id: props.chosen.id,
        permissions: checked,
      });

      if (res.status === 200) {
        setLoading(false);
        dispatch(getagent({ data: res.data }));
        setSnackbarMessage('Permissions submitted successfully!');
        setSnackbarOpen(true);
        clearForm();
        setTimeout(() => handleClose(), 1500); // Close dialog after 1.5s
      } else {
        setLoading(false);
        setSnackbarMessage('Failed to submit permissions.');
        setSnackbarOpen(true);
      }
    } catch (err) {
      setLoading(false);
      setSnackbarMessage('Error submitting permissions.');
      setSnackbarOpen(true);
    }
  };

  // Add console log to debug permissions

  return (
    <div>
      <Dialog fullWidth minWidth="sm" open={open} onClose={handleClose} aria-labelledby="customized-dialog-title">
        <DialogTitle id="customized-dialog-title">
          Set Permission...
          <IconButton onClick={handleClose} style={{ float: 'right' }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Box>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={checked.includes('Allow Input Requisition')}
                    value="Allow Input Requisition"
                    onChange={handleCheck}
                  />
                }
                label="Allow Input Requisition"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={checked.includes('Allow Add Farmer')}
                    value="Allow Add Farmer"
                    onChange={handleCheck}
                  />
                }
                label="Allow Add Farmer"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={checked.includes('Allow Sourcing')}
                    value="Allow Sourcing"
                    onChange={handleCheck}
                  />
                }
                label="Allow Sourcing"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={checked.includes('Allow Warehouse')}
                    value="Allow Warehouse"
                    onChange={handleCheck}
                  />
                }
                label="Allow Warehousing"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={checked.includes('Allow Expenses')}
                    value="Allow Expenses"
                    onChange={handleCheck}
                  />
                }
                label="Allow Expenses"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={checked.includes('Allow Processing')}
                    value="Allow Processing"
                    onChange={handleCheck}
                  />
                }
                label="Allow Processing"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={checked.includes('Allow Cash Sales')}
                    value="Allow Cash Sales"
                    onChange={handleCheck}
                  />
                }
                label="Allow Cash Sales"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={checked.includes('Allow Input Sales')}
                    value="Allow Input Sales"
                    onChange={handleCheck}
                  />
                }
                label="Allow Input Sales"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={checked.includes('Allow Approval')}
                    value="Allow Approval"
                    onChange={handleCheck}
                  />
                }
                label="Allow Approval"
              /> 
              <FormControlLabel
                control={
                  <Checkbox
                    checked={checked.includes('Allow Retirement')}
                    value="Allow Retirement"
                    onChange={handleCheck}
                  />
                }
                label="Allow Retirement"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={checked.includes('Allow Mechanization')}
                    value="Allow Mechanization"
                    onChange={handleCheck}
                  />
                }
                label="Allow Mechanization"
              /> 
              <FormControlLabel
                control={
                  <Checkbox
                    checked={checked.includes('Allow Payout')}
                    value="Allow Payout"
                    onChange={handleCheck}
                  />
                }
                label="Allow Payout"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={checked.includes('Allow Sales')}
                    value="Allow Sales"
                    onChange={handleCheck}
                  />
                }
                label="Allow Sales"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={checked.includes('Allow Inventory')}
                    value="Allow Inventory"
                    onChange={handleCheck}
                  />
                }
                label="Allow Inventory"
              />
            </FormGroup>
            <div style={{ textAlign: 'center', margin: '10px' }}>
              {loading ? (
                <Button variant="outlined" startIcon={<Loader />} disabled>
                  Loading...
                </Button>
              ) : (
                <Button variant="outlined" startIcon={<DeleteIcon />} onClick={submitPermissions}>
                  Submit Permission
                </Button>
              )}
            </div>
          </Box>
        </DialogContent>
      </Dialog>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarMessage.includes('success') ? 'success' : 'error'}
          sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
}